export const EMPTY_CONTACT = { name: "", business: "", email: "", message: "", website: "" };

export const validateContact = (form) => {
  if (!form.name.trim() || !form.email.trim() || !form.message.trim()) return "Completa nombre, email y mensaje.";
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) return "Introduce un email válido.";
  if (form.name.trim().length > 120 || form.business.trim().length > 160 || form.message.trim().length > 4000) {
    return "Revisa la longitud de los campos del formulario.";
  }
  return null;
};

export const contactErrorMessage = (error) => {
  if (error.response?.status === 422) return "Revisa los datos del formulario e inténtalo de nuevo.";
  if (error.response?.status === 429) return "Has enviado varias solicitudes. Inténtalo más tarde.";
  return "No se pudo enviar. Inténtalo de nuevo o escríbenos por email.";
};